<template>
    <q-card class="producto-camara-form" style="max-width: 100vw; display: flex; flex-direction: column">
        <!-- Header mejorado - FIJO -->
        <q-toolbar class="bg-gradient-primary text-white toolbar-fixed">
            <q-icon name="ac_unit" size="28px" class="q-mr-sm" />
            <q-toolbar-title>
                <div class="text-h6 capitalize">{{ title }}</div>
                <div class="text-caption text-white-7">{{ producto.productoDesc }}</div>
            </q-toolbar-title>

            <!-- Badge de validación -->
            <q-badge :color="res.valid ? 'positive' : 'warning'" :label="res.valid ? 'Válido' : 'Incompleto'"
                class="q-mr-md">
                <q-icon :name="res.valid ? 'check_circle' : 'error'" size="16px" class="q-ml-xs" />
            </q-badge>

            <q-btn dense flat :icon="isMaximized ? 'fullscreen_exit' : 'fullscreen'" @click="toggleMaximized">
                <q-tooltip>{{ isMaximized ? 'Restablecer' : 'Maximizar' }}</q-tooltip>
            </q-btn>

            <q-btn dense flat icon="close" v-close-popup>
                <q-tooltip>Cerrar (ESC)</q-tooltip>
            </q-btn>
        </q-toolbar>

        <!-- Contenido scrolleable -->
        <div class="row no-wrap content-scrollable">
            <!-- Columna principal: Formulario -->
            <div class="col q-pa-md scroll-area">
                <!-- Sección: Información del Producto -->
                <q-expansion-item default-opened icon="info" label="Información del Producto"
                    header-class="bg-grey-2 text-primary text-weight-medium"
                    class="q-mb-md rounded-borders overflow-hidden">
                    <q-card flat bordered>
                        <q-card-section>
                            <ProductosCommon v-model:empresa-id="form.empresa_id" v-model:alicuota-id="form.alicuota_id"
                                v-model:producto-id="form.producto_id" v-model:tipo-venta-id="form.tipo_venta_id"
                                v-model:ubicacion-id="form.ubicacion_id"
                                @update:empresa-id="validate($event, 'empresa_id')"
                                @update:alicuota-id="validate($event, 'alicuota_id')"
                                @update:producto-id="validate($event, 'producto_id')"
                                @update:tipo-venta-id="validate($event, 'tipo_venta_id')"
                                @update:ubicacion-id="validate($event, 'ubicacion_id')" :res="res" />
                        </q-card-section>
                    </q-card>
                </q-expansion-item>

                <!-- Sección: Configuración de Cámara -->
                <q-expansion-item default-opened icon="tune" label="Configuración de Cámara"
                    caption="Selección de panel y cantidad de cámaras"
                    header-class="bg-grey-2 text-primary text-weight-medium"
                    class="q-mb-md rounded-borders overflow-hidden">
                    <q-card flat bordered>
                        <q-card-section>
                            <div class="row q-col-gutter-md">
                                <div class="col-12 col-md-6">
                                    <GltnInputNumber v-model.number="form.cantidad" label="Cantidad de cámaras"
                                        hint="Número de cámaras idénticas">
                                        <template v-slot:prepend>
                                            <q-icon name="shopping_cart" />
                                        </template>
                                    </GltnInputNumber>
                                </div>
                                <div class="col-12 col-md-3">
                                    <q-option-group v-model="form.temperatura" :options="temperaturas" color="primary"
                                        @update:model-value="onTemperaturaUpdate" />
                                </div>
                                <div class="col-12 col-md-3">
                                    <q-checkbox v-model="form.piso" label="¿Lleva piso?"
                                        @update:model-value="onTemperaturaUpdate" />
                                </div>
                            </div>

                            <q-separator class="q-my-md" />
                            <div class="text-subtitle2 q-mb-sm text-grey-8">
                                <q-icon name="straighten" size="18px" class="q-mr-xs" />
                                Panel y Dimensiones
                                <q-icon name="help_outline" size="16px" class="q-ml-xs">
                                    <q-tooltip max-width="300px">
                                        Las dimensiones son actualizadas automáticamente por el Diseñador de Cámara
                                    </q-tooltip>
                                </q-icon>
                            </div>
                            <div class="row q-col-gutter-md">
                                <div class="col-12">
                                    <GltnSelectPanel ref="panelSelect" v-model="form.panel" label="Panel" tipo-panel="MC" />
                                </div>
                                <div class="col-12 col-md-2">
                                    <GltnInputNumber filled bg-color="grey-2" name="Largo" v-model.number="form.largo"
                                        label="Largo (m)" :readonly="dimensionsLocked"
                                        :hint="dimensionsLocked ? 'Bloqueado: hay 5 o más paredes' : ''">
                                        <template v-slot:prepend>
                                            <q-icon name="height" />
                                        </template>
                                    </GltnInputNumber>
                                </div>
                                <div class="col-12 col-md-2">
                                    <GltnInputNumber filled bg-color="grey-2" name="Ancho" v-model.number="form.ancho"
                                        label="Ancho (m)" :readonly="dimensionsLocked"
                                        :hint="dimensionsLocked ? 'Bloqueado: hay 5 o más paredes' : ''">
                                        <template v-slot:prepend>
                                            <q-icon name="swap_horiz" />
                                        </template>
                                    </GltnInputNumber>
                                </div>
                                <div class="col-12 col-md-2">
                                    <GltnInputNumber filled bg-color="grey-2" name="Alto" v-model.number="form.alto"
                                        label="Alto (m)" :readonly="dimensionsLocked"
                                        :hint="dimensionsLocked ? 'Bloqueado: hay 5 o más paredes' : ''">
                                        <template v-slot:prepend>
                                            <q-icon name="expand" />
                                        </template>
                                    </GltnInputNumber>
                                </div>
                                <!-- <div class="col-12 col-md-2">
                                    <GltnInputNumber readonly name="m3" v-model="form.m3" label="Volumen (m³)" filled
                                        bg-color="blue-1">
                                        <template v-slot:prepend>
                                            <q-icon name="calculate" />
                                        </template>
                                    </GltnInputNumber>
                                </div> -->
                                <div class="col-12 col-md-2">
                                    <div class="row">
                                        <q-btn unelevated label="Calcular" color="primary" @click="buildRectDesign()"
                                            icon="calculate" />
                                    </div>
                                </div>
                            </div>
                        </q-card-section>
                    </q-card>
                </q-expansion-item>

                <ProductoCamaraDesigner @update:design="onDesignUpdate" :design="initialDesign"
                    :panel-data="form.panel" />

                <!-- Sección: Paneles -->
                <q-expansion-item :default-opened="paneles.length > 0" icon="grid_on"
                    :label="`Paneles (${paneles.length})`" :caption="paneles.length > 0
                        ? `Total: ${numberFormat(totalM2, true)} m² | ${numberFormat(totalPanelesPrecio)}`
                        : 'Sin paneles cargados del diseñador'
                        " header-class="bg-grey-2 text-primary text-weight-medium"
                    class="q-mb-md rounded-borders overflow-hidden">
                    <q-card flat bordered>
                        <q-card-section class="q-pa-none">
                            <q-markup-table flat wrap-cells class="modern-table">
                                <thead>
                                    <tr>
                                        <th class="text-left">Tipo</th>
                                        <th class="text-left">Panel</th>
                                        <th class="text-left">Superficie</th>
                                        <th class="text-right">Precio</th>
                                        <th class="text-right">Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <!-- Fila Muros -->
                                    <tr v-if="lastDesign" class="table-row-hover">
                                        <td class="text-left">
                                            <q-badge color="blue-8" text-color="white">Muros</q-badge>
                                        </td>
                                        <td class="text-left">
                                            <div class="product-cell">
                                                <div class="product-name">
                                                    {{ form.panel?.label ?? form.panel?.B1_DESC ?? '—' }}
                                                </div>
                                            </div>
                                        </td>
                                        <td class="text-right text-weight-bold text-primary">
                                            {{ form.camara_data?.camara?.superficieMuros }} m2
                                        </td>
                                        <td class="text-right text-weight-bold text-primary">
                                            {{ numberFormat(form.panel?.precio ?? 0) }}
                                        </td>
                                        <td class="text-right text-weight-bold text-primary">
                                            {{ numberFormat(totalMurosPrecio) }}
                                        </td>
                                    </tr>

                                    <!-- Fila Techo -->
                                    <tr v-if="techo.m2 > 0" class="table-row-hover techo-row">
                                        <td class="text-left">
                                            <q-badge color="teal-7" text-color="white">Techo</q-badge>
                                        </td>
                                        <td class="text-left ">{{ techo?.producto?.label ?? '—' }}</td>
                                        <td class="text-right text-weight-bold text-primary">
                                            {{ form.camara_data?.camara?.superficieCamara }} m2
                                        </td>
                                        <td class="text-right text-weight-bold text-primary">
                                            {{numberFormat(techo?.producto?.precio ?? 0) }}
                                        </td>
                                        <td class="text-right text-weight-bold text-primary">
                                            {{ numberFormat(techo.total) }}
                                        </td>
                                    </tr>
                                    <!-- Fila Piso -->
                                    <tr v-if="form.piso > 0" class="table-row-hover techo-row">
                                        <td class="text-left">
                                            <q-badge color="teal-7" text-color="white">Piso</q-badge>
                                        </td>
                                        <td class="text-left text-grey-6">
                                            <GltnSelectPanel ref="pisoSelect" v-model="piso.producto" label="Panel"
                                                @update:modelValue="onPisoUpdate" />
                                        </td>
                                        <td class="text-right text-weight-bold text-primary">
                                            {{ form.camara_data?.camara?.superficieCamara }} m2
                                        </td>
                                        <td class="text-right text-weight-bold text-primary">
                                            {{numberFormat(piso?.producto?.precio ?? 0) }}
                                        </td>
                                        <td class="text-right text-weight-bold text-primary">
                                            {{ numberFormat(piso.total) }}
                                        </td>
                                    </tr>

                                    <!-- Fila de totales -->
                                    <tr v-if="lastDesign" class="totals-row">
                                        <td colspan="4" class="text-left text-weight-bold">TOTALES:</td>
                                        <td class="text-right text-weight-bold text-primary">
                                            {{ numberFormat(totalPanelesPrecio) }}
                                        </td>
                                    </tr>
                                </tbody>
                            </q-markup-table>
                        </q-card-section>
                    </q-card>
                </q-expansion-item>
                <!-- Sección: Puertas -->
                <q-expansion-item :default-opened="puertas.length > 0" icon="door_front"
                    :label="`Puertas (${puertas.length})`" :caption="puertas.length > 0
                        ? `Total: ${numberFormat(totalPuertas)}`
                        : 'Sin puertas cargadas del diseñador'
                        " header-class="bg-grey-2 text-primary text-weight-medium"
                    class="q-mb-md rounded-borders overflow-hidden">
                    <q-card flat bordered>
                        <q-card-section class="q-pa-none">
                            <q-markup-table flat wrap-cells class="modern-table">
                                <thead>
                                    <tr>
                                        <th class="text-left">Pared</th>
                                        <th class="text-left">Tipo</th>
                                        <th class="text-left">Producto</th>
                                        <th class="text-center">Ancho (m)</th>
                                        <th class="text-center">Alto (m)</th>
                                        <th class="text-center">Apertura</th>
                                        <th class="text-right">Precio</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="(puerta, index) in puertas" :key="index">
                                        <tr class="table-row-hover">
                                            <td class="text-left">
                                                <q-badge color="deep-orange-8" text-color="white">
                                                    Pared {{ puerta.wallIndex + 1 }}
                                                </q-badge>
                                            </td>
                                            <td class="text-left">
                                                <q-badge color="blue-grey-6" text-color="white">
                                                    {{ puerta.tipo }}
                                                </q-badge>
                                            </td>
                                            <td class="text-left">
                                                <div class="product-cell">
                                                    <div class="product-name">
                                                        {{ puerta.producto?.label ?? puerta.producto?.B1_DESC }}
                                                    </div>
                                                </div>
                                            </td>
                                            <td class="text-center">{{ numberFormat(puerta.ancho, true) }}</td>
                                            <td class="text-center">{{ numberFormat(puerta.alto, true) }}</td>
                                            <td class="text-center">{{ aperturaText(puerta.apertura) }}</td>
                                            <td class="text-right text-weight-bold text-primary">
                                                {{ numberFormat(puerta.producto?.precio) }}
                                            </td>
                                        </tr>
                                    </template>

                                    <!-- Fila de totales -->
                                    <tr v-if="puertas.length > 0" class="totals-row">
                                        <td colspan="6" class="text-right text-weight-bold">TOTAL:</td>
                                        <td class="text-right text-weight-bold text-primary">
                                            {{ numberFormat(totalPuertas) }}
                                        </td>
                                    </tr>
                                </tbody>
                            </q-markup-table>
                        </q-card-section>
                    </q-card>
                </q-expansion-item>

                <!-- Sección: Perfilería, consumibles y accesorios -->
                <q-expansion-item icon="settings" label="Perfilería, consumibles y accesorios de fijación" :caption="perfilerias.length > 0
                    ? `Total: ${numberFormat(totalPerfilerias)}`
                    : 'Sin perfilería calculada'" header-class="bg-grey-2 text-primary text-weight-medium"
                    class="q-mb-md rounded-borders overflow-hidden">
                    <q-card flat bordered>
                        <q-card-section>
                            <div class="row q-col-gutter-md">
                                <div class="col-12 col-md-6">
                                    <q-file outlined v-model="model" label="Archivo Adjunto" dense>
                                        <template v-slot:prepend>
                                            <q-icon name="attach_file" />
                                        </template>
                                    </q-file>
                                </div>
                            </div>

                            <!-- Tabla de perfilería calculada -->
                            <template v-if="perfilerias.length > 0">
                                <q-separator class="q-my-md" />
                                <q-markup-table flat wrap-cells class="modern-table">
                                    <thead>
                                        <tr>
                                            <th class="text-left">Descripción</th>
                                            <th class="text-left">Producto</th>
                                            <th class="text-left">Precio Unitario</th>
                                            <th class="text-left">Fórmula</th>
                                            <th class="text-right">Cantidad</th>
                                            <th class="text-right">Subtotal</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="item in perfilerias" :key="item.id" class="table-row-hover">
                                            <td class="text-left">{{ item.descripcion ?? item.variable }}</td>
                                            <td class="text-left text-grey-6 text-caption">({{
                                                item.producto?.B1_COD.trim() }}) {{ item.producto?.B1_DESC }}
                                            </td>
                                            <td class="text-left text-grey-6 text-caption">{{ numberFormat(item.precio)
                                                }}</td>
                                            <td class="text-left text-grey-6 text-caption">{{ item.formula }}</td>
                                            <td class="text-right text-weight-bold text-primary">
                                                <span v-if="item.cantidad !== null">{{ numberFormat(item.cantidad, true)
                                                    }}
                                                    {{ item.producto?.B1_UM ?? '' }}
                                                </span>
                                                <q-badge v-else color="warning" label="Error" />
                                            </td>
                                            <td class="text-right text-weight-bold text-primary">
                                                <span v-if="item.subtotal !== null">{{ numberFormat(item.subtotal)
                                                    }}</span>
                                                <q-badge v-else color="warning" label="Error" />
                                            </td>
                                        </tr>
                                        <!-- Fila de totales -->
                                        <tr class="totals-row">
                                            <td colspan="5" class="text-right text-weight-bold">TOTAL:</td>
                                            <td class="text-right text-weight-bold text-primary">
                                                {{ numberFormat(totalPerfilerias) }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </q-markup-table>
                            </template>
                        </q-card-section>
                    </q-card>
                </q-expansion-item>

                <!-- Sección: Otros Productos/Accesorios -->
                <q-expansion-item icon="build_circle"
                    :label="`Productos / Accesorios opcionales (${otrosProductos.length})`" :caption="otrosProductos.length > 0
                        ? `Total: ${numberFormat(totalOtrosProductos)}`
                        : 'Sin accesorios agregados'
                        " header-class="bg-grey-2 text-primary text-weight-medium"
                    class="rounded-borders overflow-hidden">
                    <q-card flat bordered>
                        <q-card-section class="q-pa-none">
                            <q-markup-table flat wrap-cells class="modern-table">
                                <thead>
                                    <tr>
                                        <th class="text-left">Producto</th>
                                        <th class="text-center">Precio Unit.</th>
                                        <th class="text-center">Cantidad</th>
                                        <th class="text-right">Subtotal</th>
                                        <th class="text-center" width="80">Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="(p, index) in otrosProductos" :key="p.id">
                                        <tr class="table-row-hover">
                                            <td class="text-left">
                                                <div class="product-cell">
                                                    <div class="product-name">{{ p.producto?.label }}</div>
                                                </div>
                                            </td>
                                            <td class="text-center">{{ numberFormat(p.producto.precio) }}</td>
                                            <td class="text-center">{{ numberFormat(p.cantidad, true) }}</td>
                                            <td class="text-right text-weight-bold text-primary">
                                                {{ numberFormat(p.subtotal) }}
                                            </td>
                                            <td class="text-center">
                                                <q-btn flat dense round icon="delete" size="sm" color="negative"
                                                    @click="otrosProductosDelete(index)">
                                                    <q-tooltip>Eliminar accesorio</q-tooltip>
                                                </q-btn>
                                            </td>
                                        </tr>
                                    </template>

                                    <!-- Fila para agregar accesorio -->
                                    <tr class="add-row">
                                        <td colspan="2">
                                            <GltnSelectCamaraAccesorio dense v-model="otroProducto"
                                                label="Seleccione producto" class="q-ma-xs" />
                                        </td>
                                        <td>
                                            <GltnInputNumber dense v-model.number="otroProductoCantidad"
                                                label="Cantidad" hide-hint :min="1" class="q-ma-xs" />
                                        </td>
                                        <td colspan="2" class="text-center">
                                            <q-btn unelevated label="Agregar" icon="add" size="sm" color="primary"
                                                @click="otrosProductosAdd()"
                                                :disable="!otroProducto || !otroProductoCantidad" class="q-ma-xs" />
                                        </td>
                                    </tr>

                                    <!-- Fila de total -->
                                    <tr v-if="otrosProductos.length > 0" class="totals-row">
                                        <td colspan="3" class="text-right text-weight-bold">
                                            TOTAL ACCESORIOS:
                                        </td>
                                        <td class="text-right text-weight-bold text-primary">
                                            {{ numberFormat(totalOtrosProductos) }}
                                        </td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </q-markup-table>
                        </q-card-section>
                    </q-card>
                </q-expansion-item>

                <!-- Sección: Precio y Descuentos -->
                <q-expansion-item default-opened icon="payments" label="Precio y Descuentos"
                    caption="Configure descuentos comerciales y estratégicos"
                    header-class="bg-grey-2 text-primary text-weight-medium"
                    class="q-mb-md rounded-borders overflow-hidden">
                    <q-card flat bordered>
                        <q-card-section>
                            <div class="row q-col-gutter-md">
                                <!-- PRECIO UNITARIO (readonly) -->
                                <div class="col-12 col-md-4">
                                    <GltnInputNumber name="Precio Unitario" :model-value="precio_unitario" hide-hint
                                        prefix="US$" label="Precio Unitario" readonly filled bg-color="green-1"
                                        @update:model-value="validate($event, 'precio_unitario')"
                                        :errors="res.getErrors('precio_unitario')">
                                        <template v-slot:prepend>
                                            <q-icon name="attach_money" color="positive" />
                                        </template>
                                    </GltnInputNumber>
                                </div>

                                <!-- DESCUENTO COMERCIAL (editable) -->
                                <div class="col-12 col-md-4">
                                    <GltnInputNumber v-model.number="form.descuento_comercial"
                                        label="Descuento comercial" suffix="%"
                                        @update:model-value="validate($event, 'descuento_comercial')"
                                        :errors="res.getErrors('descuento_comercial')">
                                        <template v-slot:prepend>
                                            <q-icon name="local_offer" />
                                        </template>
                                    </GltnInputNumber>
                                </div>

                                <!-- DESCUENTO ESTRATÉGICO (editable) -->
                                <div class="col-12 col-md-4" v-if="canShowEstrategico">
                                    <GltnInputNumber v-model.number="form.descuento_estrategico"
                                        label="Descuento estratégico" suffix="%"
                                        @update:model-value="validate($event, 'descuento_estrategico')"
                                        :errors="res.getErrors('descuento_estrategico')">
                                        <template v-slot:prepend>
                                            <q-icon name="trending_down" />
                                        </template>
                                    </GltnInputNumber>
                                </div>
                            </div>
                        </q-card-section>
                    </q-card>
                </q-expansion-item>
            </div>

            <!-- Columna lateral: Resumen -->
            <ProductoResumen type="camara" :form="form" :producto="producto" :total-paneles="paneles.length"
                :total-m2="totalM2" :total-paneles-subtotal="totalPanelesPrecio"
                :total-otros-productos="totalOtrosProductos" :otros-productos-count="otrosProductos.length"
                :precio-unitario="precio_unitario" :total-perfilerias="totalPerfilerias" :total-puertas="totalPuertas"
                :puertas-count="puertas.length" :validation-progress="validationProgress"
                :validation-progress-text="validationProgressText" :collapsible="true">
            </ProductoResumen>
        </div>

        <!-- Footer con acciones - FIJO -->
        <q-separator />
        <q-card-actions class="q-pa-md actions-fixed bg-white">
            <div class="row full-width q-gutter-sm">
                <div class="col">
                    <q-btn outline label="Cancelar" color="grey-7" icon="close" v-close-popup class="full-width" />
                </div>
                <div class="col" v-if="props.oper !== 'view'">
                    <q-btn unelevated :label="props.oper === 'add' ? 'Agregar al carrito' : 'Actualizar'"
                        :color="res.valid ? 'primary' : 'grey'"
                        :icon="props.oper === 'add' ? 'add_shopping_cart' : 'save'" @click="cartSave"
                        :disable="!res.valid" :loading="loading" class="full-width">
                        <template v-slot:loading>
                            <q-spinner-hourglass size="20px" />
                        </template>
                    </q-btn>
                </div>
            </div>
        </q-card-actions>
        <q-inner-loading :showing="loading">
            <q-spinner-hourglass size="50px" color="primary" />
        </q-inner-loading>
    </q-card>
</template>

<script setup>
import { computed, reactive, ref, onMounted, onUnmounted, nextTick, watch, watchEffect } from "vue";
import { round, evaluate, ceil } from "mathjs";
import { useCartStore } from "@/stores/useCartStore.js";
import { usePage } from "@inertiajs/vue3";
import ConfigService from "@/services/ConfigService.js";
import GltnInputNumber from "@/components/form/GltnInputNumber.vue";
import GltnSelectCamaraAccesorio from "@/components/form/GltnSelectCamaraAccesorio.vue";
import GltnSelectPanel from "@/components/form/GltnSelectPanel.vue";
import numberFormat from "@/helpers/numberFormat";
import ProductoCamaraDesigner from "./components/ProductoCamaraDesigner.vue";
import ProductoResumen from "../ProductoResumen.vue";
import ProductoResumenTips from "../ProductoResumenTips.vue";
import ProductosCommon from "./components/ProductosCommon.vue";
import suite from "./ProductoCamaraValidation.js";
import CamaraConfigService from "@/services/CamaraConfigService.js";
import { useProductoTitle } from "@/composables/useProductoTitle.js";

const page = usePage();
const canShowEstrategico = computed(() => page.props?.auth?.can.includes('presupuesto.item.estrategico'));

const props = defineProps({
    oper: String,
    producto: Object,
    presupId: Number,
    formulario: Object,
    isSavedPresup: {
        type: Boolean,
        default: false,
    },
});
const emits = defineEmits(["added", "updated", "maximized-toggle"]);
const isMaximized = ref(false);

function toggleMaximized() {
    isMaximized.value = !isMaximized.value;
    emits("maximized-toggle");
}
const panelSelect = ref(null)
const pisoSelect = ref(null)
const otroProducto = ref(null);
const otroProductoCantidad = ref(0);
const otrosProductos = ref([]);
const loading = ref(false);
const variables = reactive({
    selladores: 0,
    perfileria: 0,
});
const camaraConfig = ref(null);
const perfilerias = ref([]);
const initialDesign = ref(null);
const temperaturas = [
    { label: "Baja temperatura", value: "bt" },
    { label: "Media temperatura", value: "mt" },
];
const form = reactive({
    alicuota_id: 2,
    empresa_id: "",
    tipo_venta_id: "",
    tipo: "conv",
    ancho: 0,
    largo: 0,
    alto: 0,
    m3: 0,
    panel: "",
    accesorios: [],
    perfileria_ext_valor: 0,
    perfileria_int_valor: 0,
    perfileria_ext: false,
    perfileria_int: false,
    selladores: 0,
    iluminacion: false,
    kit_baja: false,
    kit_techo: false,
    valvula: false,
    resistencia: false,
    cortina: false,
    hongos: false,
    cantidad: 1,
    precio_unitario: 0,
    descuento_comercial: 0,
    descuento_estrategico: 0,
    subtotal: 0,
    total: 0,
    design: null,
    temperatura: "mt",
    camara_data: null,
    piso: false,
});
// TITULO
const title = useProductoTitle(props.oper,'camara');

const paneles = computed(() => {
    return form.accesorios.length > 0
        ? form.accesorios.filter((x) => x.tipo == "panelCamara")
        : [];
});


const techo = reactive({
    producto: {},
    m2: 0,
    total: 0,
});

const piso = reactive({
    producto: '',
    m2: 0,
    total: 0,
});

const panelesMuroCantidad = computed(() => ceil(lastDesign.value?.camara?.totalPanelesPerimetro / Number(form.panel?.ancho ?? 1)) ?? 0);
const totalMurosPrecio = computed(() => round(lastDesign.value?.camara?.superficieMuros * Number(form.panel?.precio ?? 0), 2));
const totalPanelesPrecio = computed(() => round(totalMurosPrecio.value + Number(techo.total ?? 0) + Number(piso.total ?? 0), 2));



const totalM2 = computed(() =>
    round(
        lastDesign.value?.camara?.superficieMuros +
        (techo.m2 ?? 0) +
        (piso.m2 ?? 0),
        2
    )
);



const totalOtrosProductos = computed(() =>
    round(
        otrosProductos.value.reduce((a, b) => a + Number.parseFloat(b.subtotal), 0),
        2
    )
);

const totalPerfilerias = computed(() =>
    round(
        perfilerias.value.reduce((a, b) => a + (b.subtotal ?? 0), 0),
        2
    )
);

const aperturaText = (value) => {
    switch (value) {
        case 'in-left': return 'Interior izquierda';
        case 'in-right': return 'Interior derecha';
        case 'out-left': return 'Exterior izquierda';
        case 'out-right': return 'Exterior derecha';
        default: return '';
    }
};

const lastDesign = ref(null);

const puertas = computed(() => lastDesign.value?.puertas ?? []);

const totalPuertas = computed(() =>
    round(
        puertas.value.reduce((a, b) => a + Number.parseFloat(b.producto?.precio ?? 0), 0),
        2
    )
);

const precio_unitario = computed(() => {
    return (
        round(totalPanelesPrecio.value, 2) +
        round(form.perfileria_ext_valor, 2) +
        round(form.perfileria_int_valor, 2) +
        round(form.selladores, 2) +
        totalOtrosProductos.value +
        totalPerfilerias.value +
        totalPuertas.value
    );
});

const subtotal = computed(() => round(precio_unitario.value, 2) * round(form.cantidad, 2));

const descuento_monto = computed(() => {
    // Descuento comercial
    const desc1 = subtotal.value * (form.descuento_comercial / 100);
    const precioConDesc1 = subtotal.value - desc1;
    // Descuento estratégico sobre el precio ya descontado
    const desc2 = precioConDesc1 * (form.descuento_estrategico / 100);
    return round(desc1 + desc2, 2);
});

const total = computed(() => {
    return round(subtotal.value - descuento_monto.value, 2);
});

// Actualizar automaticamente form.total y form.subtotal cuando cambian
watchEffect(() => {
    form.total = total.value;
    form.subtotal = subtotal.value;
});
// calculo m3
const calculoM3 = () => {
    form.m3 = round(form.ancho * form.largo * form.alto, 2);
    form.precio_unitario = round(form.cantidad * form.precio_unitario, 2);
    form.total = round(form.cantidad * form.precio_unitario, 2);
};
// VALIDACION
const res = ref();
res.value = suite.get();
const validate = (value, name) => {
    res.value = suite(name, form);
    calculoM3();
};

const getVariablesCamara = async () => {
    loading.value = true;
    camaraConfig.value = await CamaraConfigService.index();
    loading.value = false;
};

const updateVariables = () => {
    form.selladores = variables.selladores * totalM2.value;

    const valorPerfileria = totalPanelesPrecio.value * variables.perfileria;
    form.perfileria_ext_valor = form.perfileria_ext ? valorPerfileria : 0;
    form.perfileria_int_valor = form.perfileria_int ? valorPerfileria : 0;
};

const setValues = () => {
    for (let key in props.formulario) {
        if (key === "accesorios") {
            form.accesorios = props.formulario[key].filter((x) => x.tipo === "panelCamara");
            otrosProductos.value = props.formulario[key]
                .filter((x) => x.tipo === "accesorioCamara")
                .map((x) => ({
                    producto: x.producto,
                    cantidad: x.cantidad ?? Math.round((x.total ?? 0) / Number(x.producto?.precio ?? 1)),
                    tipo: x.tipo,
                    subtotal: x.subtotal ?? x.total,
                }));
            continue;
        }
        form[key] = props.formulario[key];
    }
    panelSelect.value?.setValue(form.panel)

    const pisoProductoId = props.formulario.camara_data?.piso?.producto_id;
    if (pisoProductoId) {
        // La fila de Piso está detrás de v-if="form.piso"; recién se acaba de fijar arriba,
        // así que hay que esperar a que Vue monte esa fila antes de acceder al ref.
        nextTick(() => {
            pisoSelect.value?.setValue(pisoProductoId);
        });
    }

    if (props.formulario.design) {
        initialDesign.value = {
            ...props.formulario.design,
            puertas: props.formulario.camara_data?.puertas ?? [],
        };
    }

};

// Progress de validación
const validationProgress = computed(() => {
    const requiredFields = ["empresa_id", "alicuota_id", "tipo_venta_id"];
    let completed = 0;
    let total = requiredFields.length;

    for (const field of requiredFields) {
        if (form[field]) completed++;
    }

    // Verificar si tiene paneles
    if (paneles.value.length > 0) {
        completed++;
    }
    total++;

    return completed / total;
});

const validationProgressText = computed(() => {
    const percent = Math.round(validationProgress.value * 100);
    return `Formulario ${percent}% completo`;
});

onMounted(async () => {
    await getVariablesCamara();
    if (props.oper === "edit" || props.oper === 'view') {
        setValues();
    }
    validate();

    // Agregar keyboard shortcut
    document.addEventListener("keydown", handleKeyboardShortcut);
});

onUnmounted(() => {
    document.removeEventListener("keydown", handleKeyboardShortcut);
});

const handleKeyboardShortcut = (e) => {
    if ((e.ctrlKey || e.metaKey) && e.key === "s") {
        e.preventDefault();
        if (res.value.valid) {
            cartSave();
        }
    }
};

const otrosProductosAdd = () => {
    otrosProductos.value.push({
        producto: { ...otroProducto.value },
        cantidad: otroProductoCantidad.value,
        tipo: "accesorioCamara",
        subtotal: otroProducto.value.precio * otroProductoCantidad.value,
    });
    updateVariables();
};

const otrosProductosDelete = (index) => {
    otrosProductos.value.splice(index, 1);
    updateVariables();
};

const perimeterWallCount = computed(
    () => lastDesign.value?.paneles?.filter((p) => !p.interna).length ?? 0
);
const dimensionsLocked = computed(() => perimeterWallCount.value >= 5);

const DESIGNER_GRID_STEP = 50;
const DESIGNER_CANVAS_SIZE = 500;

function buildRectDesign() {
    const largoM = form.largo;
    const anchoM = form.ancho;
    const altoM = form.alto;
    const cx = DESIGNER_CANVAS_SIZE / 2;
    const cy = DESIGNER_CANVAS_SIZE / 2;
    const halfW = (Number(anchoM) * DESIGNER_GRID_STEP) / 2;
    const halfH = (Number(largoM) * DESIGNER_GRID_STEP) / 2;
    if (!(largoM > 0 && anchoM > 0 && altoM > 0)) return;
    initialDesign.value = {
        camaraAltura: Number(altoM),
        isClosed: true,
        vertices: [
            { x: cx - halfW, y: cy - halfH },
            { x: cx + halfW, y: cy - halfH },
            { x: cx + halfW, y: cy + halfH },
            { x: cx - halfW, y: cy + halfH },
        ],
        paredesInternas: [],
        puertas: [],
    };
}



const rebuildPaneles = () => {
    if (!lastDesign.value || !form.panel?.value || lastDesign.value.paneles.length === 0) {
        return;
    }

    const otrosAccesorios = form.accesorios.filter((x) => x.tipo !== 'panelCamara');
    form.accesorios = [
        ...otrosAccesorios,
        ...lastDesign.value.paneles.map((pared) => ({
            ubicacion: pared.nombre,
            producto_id: form.panel.value,
            largo: pared.ancho,
            alto: pared.alto,
            m2: round(pared.ancho * pared.alto, 2),
            total: round(pared.ancho * pared.alto * Number(form.panel.precio), 2),
            producto: form.panel,
            cantidad: pared.panelCantidad || 1,
            tipo: 'panelCamara',
        })),
    ];

    updateVariables();
};
const panelesCantidadTotal = computed(() => {
    return lastDesign.value ? lastDesign.value.camara.totalPaneles : 0;
});

const onPisoUpdate = (producto) => {
    piso.producto = producto;
    piso.m2 = form.camara_data?.camara?.superficieCamara  ?? 0;
    piso.total = round(form.camara_data?.camara?.superficieCamara  * (producto?.precio ?? 0), 2);
    form.camara_data = {
        ...(form.camara_data ?? {}),
        piso: { producto_id: producto?.value ?? null },
    };
};

const onDesignUpdate = (data) => {
    form.largo = null;
    form.ancho = null;
    form.alto = null;
    // TODO: mapear largo/ancho/alto de la cámara desde el diseñador cuando se defina la regla.
    // design.camara.perimetro = perímetro total de la cámara en metros
    // design.camara.superficie = superficie total de la cámara en m²
    // design.paneles[i].nombre = nombre de la pared (ej. "Pared 1", "Cierre")
    // design.paneles[i].ancho  = longitud de la pared en metros
    // design.paneles[i].alto   = altura de extrusión en metros
    techo.producto = form?.panel ?? '';
    techo.m2 = data?.camara?.superficieCamara ?? 0;
    techo.total = round(data?.camara?.superficieCamara * (form.panel?.precio ?? 0), 2);

    lastDesign.value = data;
    form.design = { ...data.camara.design, puertas: data.puertas };
    form.camara_data = { ...data, piso: form.camara_data?.piso };
    calcularPerfileria(data.camara, data.puertas);
    rebuildPaneles();
};

const onTemperaturaUpdate = () => {
    if (lastDesign.value) {
        calcularPerfileria(lastDesign.value.camara, lastDesign.value.puertas);
    } else {
        perfilerias.value = [];
    }
};

const calcularPerfileria = (
    { perimetro,
        esquinasTotal,
        esquinasInternas,
        esquinasExternas,
        paredMasCorta,
        design: { camaraAltura },
        superficiePaneles,
        superficieCamara,
        m2Paredes,
        totalPaneles }, puertas) => {
    if (!camaraConfig.value) {
        return;
    }

    const camaraConfigData = camaraConfig.value[form.temperatura] || [];

    const scope = {
        perimetro,
        esquinasTotal,
        esquinasInternas,
        esquinasExternas,
        camaraAltura,
        paredMasCorta,
        anchoPanel: form.panel ? form.panel.ancho : 0,
        piso: form.piso ? 1 : 0,
        // Constantes — los nombres deben coincidir con los usados en las fórmulas del DB
        perfilLargo: 4,
        perfilMetalicoExteriorLargo: 2.44,
        perfilMetalicoInteriorLargo: 2.44,
        perfilTapaLargo: 4,
        perfilBaseLargo: 4,
        totalPuertas: puertas.length,
        totalPaneles,
        superficieCamara,
        superficiePaneles,
        m2Paredes
    };

    perfilerias.value = camaraConfigData.map((row) => {
        try {
            const cantidadRaw = evaluate(row.formula, scope);
            const cantidad = row.producto?.B1_UM === "UN" ? Math.ceil(cantidadRaw) : round(cantidadRaw, 4);
            const precio = form.piso && row.precio_alternativo ? row.precio_alternativo : row.precio;
            const subtotal = round(cantidad * precio, 2);
            return { ...row, cantidad, subtotal };
        } catch(e) {
            console.log("Error al calcular perfilería para", row.variable, ":", e.message);
            return { ...row, cantidad: null, subtotal: null };
        }
    });
};


watch(() => form.panel, () => {
    rebuildPaneles();
});

// GESTION DE CART
const cartStore = useCartStore();
const cartSave = () => {
    if (props.oper === "add") {
        cartAdd();
    } else {
        cartUpdate();
    }
};

const otrosProductosParse = () => {
    return otrosProductos.value.map((x) => {
        return {
            producto_id: x.producto.id,
            cantidad: x.cantidad,
            subtotal: x.subtotal,
            total: x.subtotal,
            producto: x.producto,
            tipo: "accesorioCamara",
        };
    });
};

const cartUpdate = async () => {
    loading.value = true;
    try {
        form.total = total.value;
        form.accesorios = [...form.accesorios, ...otrosProductosParse()];

        await cartStore.itemUpdate(
            {
                form: { ...form },
                producto: { ...props.producto },
            },
            props.isSavedPresup,
            props.presupId
        );
        emits("updated");
    } finally {
        loading.value = false;
    }
};
const cartAdd = async () => {
    form.total = total.value;
    form.accesorios = [...form.accesorios, ...otrosProductosParse()];
    await cartStore.itemAdd(
        {
            form: { ...form },
            producto: { ...props.producto },
        },
        props.isSavedPresup,
        props.presupId
    );
    emits("added");
};

</script>

<style lang="scss" scoped>
@use 'sass:color';

.producto-camara-form {
    border-radius: 16px;
    overflow: hidden;

    // Gradiente para el header
    .bg-gradient-primary {
        background: linear-gradient(135deg,
                var(--q-primary) 0%,
                color.adjust(#1976d2, $lightness: -10%) 100%);
    }

    // Toolbar fijo arriba
    .toolbar-fixed {
        flex-shrink: 0;
        position: sticky;
        top: 0;
        z-index: 100;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    // Contenido scrolleable
    .content-scrollable {
        flex: 1;
        overflow: hidden;
    }

    .scroll-area {
        overflow-y: auto;
        max-height: 100%;

        &::-webkit-scrollbar {
            width: 8px;
        }

        &::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 4px;
        }

        &::-webkit-scrollbar-thumb {
            background: #888;
            border-radius: 4px;

            &:hover {
                background: #555;
            }
        }
    }

    // Acciones fijas abajo
    .actions-fixed {
        flex-shrink: 0;
        box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
    }
}

// Sticky summary en desktop
.sticky-summary {
    position: sticky;
    top: 20px;
}

// Card de resumen
.summary-card {
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

// Filas del resumen
.summary-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;
    gap: 16px;

    &:not(:last-child) {
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    }

    span:first-child {
        flex: 1;
    }

    span:last-child {
        text-align: right;
        word-break: break-word;
    }
}

// Tablas modernas
.modern-table {
    border-radius: 8px;
    overflow: hidden;

    :deep(thead) {
        background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);

        tr th {
            color: white;
            font-weight: 600;
            padding: 12px;
            text-transform: uppercase;
            font-size: 0.75rem;
        }
    }

    :deep(tbody) {
        tr {
            transition: background-color 0.2s ease;

            &.table-row-hover:hover {
                background-color: rgba(25, 118, 210, 0.04);
            }

            &.add-row {
                background-color: #fafafa;
                border-top: 2px solid #1976d2;
            }

            &.totals-row {
                background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
                font-size: 1rem;

                td {
                    padding: 12px;
                    border-top: 2px solid #1976d2;
                }
            }
        }
    }
}

// Celdas de producto
.product-cell {
    .product-name {
        font-weight: 500;
        color: #212121;
    }
}

// Toggles modernos
.modern-toggle {
    padding: 12px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    transition: all 0.3s ease;

    &:hover {
        background-color: rgba(25, 118, 210, 0.04);
    }

    .toggle-content {
        display: flex;
        align-items: center;
        gap: 8px;
    }
}

// Radio groups modernos
.modern-radio-group {
    :deep(.q-radio) {
        padding: 8px 16px;
        border: 1px solid #e0e0e0;
        border-radius: 8px;
        margin-right: 8px;
        transition: all 0.3s ease;

        &:hover {
            background-color: rgba(25, 118, 210, 0.04);
        }
    }
}

// Campo calculado inline
.calculated-field-inline {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px;
    background: linear-gradient(135deg, #f5f5f5 0%, #e8eaf6 100%);
    border-radius: 8px;
    border-left: 4px solid #1976d2;
}

// Badge de ayuda
kbd {
    background: #f4f4f4;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 2px 6px;
    font-family: monospace;
    font-size: 0.85em;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

// Expansion items
:deep(.q-expansion-item) {
    border: 1px solid rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;

    &.q-expansion-item--expanded {
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    }

    .q-expansion-item__container {
        .q-item {
            min-height: 56px;
        }
    }
}

// Mejora de tipografía
.text-white-7 {
    color: rgba(255, 255, 255, 0.7);
}

// Responsive
@media (max-width: 1023px) {
    .producto-camara-form {
        border-radius: 0;
    }

    .sticky-summary {
        position: relative;
        top: 0;
    }
}

// Animaciones
@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}
</style>
